import { BlocksIconChevronDown } from 'blocks-nextjs/blocks-web-components/components/icon/icons/chevron-down';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconChevronDown = createComponent({ react: React, tagName: 'cat-icon-chevron-down', elementClass: BlocksIconChevronDown });
